module.exports = __webpack_public_path__ + "static/team20-f3ab52c9cdae3b8472b5dba283d2e997.jpg";